// Updated content - ideal customer focus (Eugene Schwartz approach)

export const navigation = [
  { label: 'בית', path: '/' },
  { label: 'שירותים', path: '/services' },
  { label: 'השיטה', path: '/method' },
  { label: 'למומחים', path: '/experts' },
  { label: 'לחברות B2B', path: '/ceo' },
  { label: 'מי אנחנו', path: '/about' },
  { label: 'תוצאות ובשטח', path: '/results' },
  { label: 'יצירת קשר', path: '/contact' }
];

export const heroStats = [
  { value: 'מאות', suffix: 'מ׳ ש״ח', label: 'במכירות מצטברות' },
  { value: '400%', suffix: '', label: 'צמיחה ב-18 חודשים' },
  { value: '1,000+', suffix: '', label: 'אנשי מקצוע שלמדו מהשיטה' },
  { value: 'אלפי', suffix: '', label: 'פרויקטים מורכבים' }
];

export const trustBar = [
  'מאות מיליוני שקלים במכירות',
  '400% צמיחה באחד ממקרי הבוחן',
  'מעל 1,000 אנשי מקצוע שלמדו מהשיטה',
  'אלפי פרויקטים מורכבים',
  'עבודה מול הגופים המוסדיים והמקצועיים בישראל'
];

// Now only 3 focused pain points
export const painPoints = [
  {
    id: 1,
    title: 'אנחנו עובדים עם כמה ספקים והכל נופל בין הכיסאות',
    short: 'תכלול לקוי בין ספקי שיווק',
    response:
      'בעסקים צומחים, זו נקודת התורפה הקריטית. יש לכם מוצר עם שולי רווח מצוינים (50%+), אבל רווחים נשחקים על חוסר סנכרון.\n\nGal&Blizovsky לוקחת פיקוד: אנחנו האסטרטגים והמנהלים. אנחנו מתכללים את כל הכלים (קמפיינים, דפים, תוכן, SEO) למערכת אחת מסונכרנת שמדברת באותה שפה, עם יעד מכירות אחד ברור.',
    cta: 'בואו נרכז את השיווק שלכם למקום אחד'
  },
  {
    id: 2,
    title: 'הלידים מגיעים, אבל הם פשוט לא רלוונטיים ושורפים לצוות המכירות את הזמן',
    short: 'איכות פנייה במקום כמות',
    response:
      'כשיש לכם עסק עובד, הזמן של צוות המכירות הוא משאב יקר. כמות הלידים לא משנה אם הליד מגיע לא בשל, לא מבין את הערך, או לא באמת צריך את השירות.\n\nהמערך שלנו מתמקד באיכות הפנייה: אנו בונים מסעות לקוח, דפי נחיתה מחממים ושאלות סינון שמוודאים שרק לקוחות פוטנציאליים אידיאליים יגיעו לשיחה איתכם.',
    cta: 'עברו למודל של לידים מסוננים ואיכותיים'
  },
  {
    id: 3,
    title: 'אנחנו מקבלים דוחות ביצועים משעממים, אבל השורה התחתונה נשארת בינונית',
    short: 'מדידה לפי תוצאות, לא קליקים',
    response:
      'אתם צודקים לחלוטין. קליקים וחשיפות לא משלמים משכורות.\n\nאנחנו פועלים מתוך סטנדרט ניהולי-ביצועי עליון: היעד שלנו הוא השורה התחתונה שלכם. המדידה שלנו מתמקדת בשאלה כמה הזדמנויות עסקיות אמיתיות המערך ייצר, ואיך אפשר לשפר את יחסי ההמרה מליד ללקוח משלם.',
    cta: 'התחילו למדוד תוצאות אמיתיות בשטח'
  }
];

// 5 services (down from 6)
export const services = [
  {
    n: '01',
    title: 'בניית אסטרטגיה עסקית-שיווקית',
    sub: 'מפת דרכים, לא ניחושים. בסיס לכל פעילות שיווקית.',
    body: 'עסק שמכניס מיליונים לא פועל על ניחושים. אנחנו חוקרים את המוצר שלכם, מנתחים את הלקוחות הנאמנים הקיימים, ומגדירים מסלול מדויק כדי לשכפל אותם. הכל מתחיל במפת דרכים ברורה: מי הלקוח האידיאלי, מה הערך המבדל, מה ערוצי הגיוס הנכונים, ומה הסדר שבו נבנה את המערכת.'
  },
  {
    n: '02',
    title: 'ניהול דיגיטל מקצה לקצה (תכלול מלא)',
    sub: 'גוף אחד אחראי על כל האקו-סיסטם הדיגיטלי.',
    body: 'קמפיינים, תוכן, SEO, אוטומציות ובוטים. הכל מנוהל על ידינו כגוף אחד. אין יותר "זה באחריות הספק השני". אנחנו לוקחים אחריות על כל האקו-סיסטם הדיגיטלי שלכם, מסנכרנים אותו, ומוודאים שהוא מייצר תוצאה.'
  },
  {
    n: '03',
    title: 'ייצור לידים איכותיים (Quality Lead Gen)',
    sub: 'פחות רעש, יותר הזדמנויות אמיתיות.',
    body: 'אנו יודעים שלעסק פעיל אין זמן לבזבז. המערכות שלנו בנויות כדי לחמם, לסנן ולהבשיל את הלקוח, כך שכאשר הפנייה מגיעה אליכם — מדובר בלקוח שמבין בדיוק מה הערך שלכם ולמה הוא צריך אתכם עכשיו.'
  },
  {
    n: '04',
    title: 'אפיליאייט ושיווק שותפים',
    sub: 'מנוע צמיחה נוסף שמבוסס על תוצאות.',
    body: 'כשיש לכם מוצר חזק ושולי רווח רחבים, שילוב של מערך שותפים יכול להיות מכפיל כוח משמעותי. אנחנו מקימים, מתגמלים, ומנהלים את כל תשתית השותפים כדי לייצר לכם זרם עבודה נוסף המבוסס על תוצאות.'
  },
  {
    n: '05',
    title: 'מסעות לקוח ובניית תשתיות המרה',
    sub: 'הופכים מתעניינים ללקוחות משלמים.',
    body: 'כל שלב שהלקוח עובר מרגע החשיפה למותג ועד הסגירה. אנו מפתחים דפי נחיתה שממירים, תסריטים, מסרים וניוזלטרים שהופכים מתעניינים מבולבלים ללקוחות משלמים.'
  }
];

// 4 method steps (down from 6)
export const methodSteps = [
  {
    n: '01',
    title: 'אבחון העסק הקיים',
    body: 'אתם באים עם מוצר עובד ולקוחות נאמנים. אנו מפרקים את הנתונים כדי להבין מה בדיוק עובד כרגע, איפה נמצא הכסף שאתם משאירים על הרצפה, ומה הצוואר הצר שמונע מהמערך לצמוח בקצב הנכון.'
  },
  {
    n: '02',
    title: 'בחירת הכלים המדויקים',
    body: 'אנחנו לא "דוחפים" קמפיינים אם מה שאתם צריכים זה בניית קהילה, ולא דוחפים אוטומציה אם אתם צריכים מסר מדויק יותר. האסטרטגיה מכתיבה את הכלים — לא הפוך.'
  },
  {
    n: '03',
    title: 'הקמת התשתית וניהול הספקים',
    body: 'מקימים את הנכסים (דפים, מערכות, מודעות). מפעילים את המומחים הנכונים תחת הניצוח והאחריות שלנו. אתם לא מתעסקים בתיאומים, בעדכוני סטטוס או בריבים בין ספקים — אנחנו אחראים על הכל.'
  },
  {
    n: '04',
    title: 'הפעלה, בקרה ושיפור',
    body: 'המערכת באוויר, אבל העבודה רק מתחילה. אנחנו מודדים הכל במונחים של עסקאות והכנסות, לא של לייקים. מזהים מה מייצר ROI ומגבירים את הקצב.'
  }
];

export const team = [
  {
    name: 'ציון גל',
    role: 'מנכ״ל החברה — הזרוע הניהולית-הנדסית',
    bio: 'ציון מביא לחברה חשיבה מערכתית וביצועית חסרת פשרות. כמהנדס מומחה ומהראשונים שעיצבו את התחום הסולארי בישראל, ציון ניהל אלפי פרויקטים מורכבים מול הגופים המחמירים במשק (משרד ראש הממשלה, בנקים, רשויות ועוד).\n\nבעולם שבו רוב ספקי הדיגיטל פועלים מתוך אלתור, ציון מחדיר ל-Gal&Blizovsky סטנדרט של סדר, תכנון מוקפד, ניהול סיכונים ובקרה. הוא מוודא שכל המערך השיווקי שלכם מנוהל במדדי יעילות של פרויקט הנדסי: בודקים קלט, מודדים פלט, ומבטיחים תוצאה.',
    initials: 'צ.ג',
    image: 'https://customer-assets.emergentagent.com/job_gal-blizovsky/artifacts/m6e0ovqk_image.png'
  },
  {
    name: 'רז בליזובסקי',
    role: 'סמנכ״ל דיגיטל וצמיחה — הזרוע הדיגיטלית-שיווקית',
    bio: 'רז חי ונושם צמיחה דיגיטלית. עם ניסיון בהובלת מהלכי מכירה ושיווק בהיקפים של מאות מיליוני שקלים, והקמת קהילות משווקים מהמשמעותיות בישראל, רז מביא את ההבנה המדויקת של איך מניעים לקוח לפעולה.\n\nתחת שרביטו, החברה אינה מייצרת "קמפיינים יפים", אלא מכונות תנועה ולידים חדות כתער, שהוכחו בשטח ושוק המקצוענים בישראל עוקב ולומד מהן.',
    initials: 'ר.ב',
    image: null
  }
];

// 2 case studies (down from 3)
export const caseStudies = [
  {
    name: 'ארגון "לחיות בכבוד"',
    headline: 'מעמותה מקומית לארגון חברתי מהמובילים בישראל',
    body: 'איך הפכנו עמותה מקומית לארגון חברתי מהמובילים והמשפיעים בישראל באמצעות בניית אמון דיגיטלי, קהל, ומערך שיווקי מתקדם — מהלך שמדגים את הכוח של שפה, אסטרטגיה, מיקוד בקהל ותשתיות שיווקיות.',
    metric: '#1'
  },
  {
    name: 'GTN Digital Group',
    headline: 'מאיש אחד לחברה מובילה בתחומה',
    body: 'צמיחה מואצת מפעילות של אדם אחד לחברה מובילה בתחומה בזכות פריסה דיגיטלית אסטרטגית וניהול שותפים חכם — יכולת מוכחת לחבר אסטרטגיה, ניהול שיווקי ותשתיות דיגיטל לצמיחה ארגונית משמעותית.',
    metric: '∞'
  }
];

export const institutionalClients = [
  'משרד ראש הממשלה',
  'בנקים מובילים',
  'חברות ביטוח',
  'בתי משפט',
  'משטרת ישראל',
  'כיבוי אש',
  'עיריות ורשויות',
  'גופים מוסדיים',
  'יזמים פרטיים',
  'חברות ענק'
];

export const proofPoints = [
  {
    label: 'היקפי ענק',
    body: 'ניסיון בהובלת מהלכי שיווק ומכירה בסדר גודל מצטבר של מאות מיליוני שקלים בחמש השנים האחרונות.'
  },
  {
    label: 'צמיחה חריגה',
    body: '400% צמיחה בתוך 18 חודשים בלבד באחד ממקרי הבוחן המובילים שלנו (פרויקט כוח התודעה).'
  },
  {
    label: 'סמכות מקצועית',
    body: 'מעל 1,000 משווקים ואנשי מקצוע למדו, הודרכו ומיישמים את השיטות שלנו — השוק לומד מאיתנו.'
  },
  {
    label: 'ניסיון מוסדי וניהולי',
    body: 'עמידה בסטנדרטים הקפדניים ביותר בעבודה מול בנקים, חברות ענק, גופים ממשלתיים ובתי משפט במסגרת פרויקטים הנדסיים מורכבים.'
  }
];

export const images = {
  hero: 'https://images.unsplash.com/photo-1546349851-64285be8e9fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzc3OTA2MzMxfDA&ixlib=rb-4.1.0&q=85',
  whatWeDo: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxzdHJhdGVneSUyMGRhc2hib2FyZHxlbnwwfHx8fDE3Nzc5MDYzMzF8MA&ixlib=rb-4.1.0&q=85',
  philosophy: 'https://images.unsplash.com/photo-1709626011485-6fe000ea2dbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxnZW9tZXRyaWMlMjBhYnN0cmFjdHxlbnwwfHx8fDE3Nzc5MDYzMzF8MA&ixlib=rb-4.1.0&q=85',
  about: 'https://images.unsplash.com/photo-1760611656160-7c7bf7e6da9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxleGVjdXRpdmUlMjBib2FyZHJvb218ZW58MHx8fHwxNzc3OTA2MzMxfDA&ixlib=rb-4.1.0&q=85',
  authority: 'https://images.unsplash.com/photo-1773433418438-584be45c018e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxpbnN0aXR1dGlvbmFsJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzc3OTA2MzMxfDA&ixlib=rb-4.1.0&q=85',
  affiliate: 'https://images.unsplash.com/photo-1480944657103-7fed22359e1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMG5ldHdvcmt8ZW58MHx8fHwxNzc3OTA2MzMxfDA&ixlib=rb-4.1.0&q=85',
  results: 'https://images.unsplash.com/photo-1730382624709-81e52dd294d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxncm93dGglMjBjaGFydHxlbnwwfHx8fDE3Nzc5MDYzMzF8MA&ixlib=rb-4.1.0&q=85'
};

// LocalStorage helpers retained for legacy compatibility (no longer used)
